var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckmarkSsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 556,
    viewBox: "0 0 600 556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 96.50,446.83 C44.80,386.81 2.39,337.21 2.26,336.61 C2.14,336.00 3.75,333.51 5.86,331.09 L 9.69,326.67 L 84.60,368.95 C125.79,392.21 160.50,411.86 161.73,412.63 C163.87,413.96 164.22,413.66 170.23,405.35 C228.02,325.43 290.89,251.19 356.00,185.99 C419.64,122.26 479.84,72.00 541.00,31.53 C562.27,17.45 589.88,0.47 590.40,1.15 C596.43,9.12 597.91,11.47 597.27,12.02 C586.71,21.16 547.40,58.94 528.48,78.13 C400.63,207.77 304.26,344.92 209.76,531.73 L 197.50,555.97 L 194.00,555.95 C190.60,555.94 187.82,552.82 96.50,446.83 Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkSsl);
export default __webpack_public_path__ + "static/media/icon-checkmark-ssl.ec20f56ee0e12d2afb1a097b0eb3ee47.svg";
export { ForwardRef as ReactComponent };